<template>
  <widget
    :color="color"
    icon="fa fa-comment"
    title="Inbound chats today"
    :value="value"
  />
</template>

<script>
import apiRealtime from '@/apis/realtime'

import Widget from '@/components/widget/widget8'

export default {
  components: {
    Widget
  },
  props: {
    refresh: Boolean,
    direction: String
  },
  data() {
    return {
      color: this.$getChatColor[0],
      value: 0
    }
  },
  watch: {
    refresh: {
      immediate: true,
      handler(val) {
        if (val) this.getChatSession()
      }
    }
  },
  methods: {
    async getChatSession() {
      try {
        const data = await apiRealtime.getChatSession({
          direction: this.direction
        })
        this.value = data.total

        this.$emit('reset', 'chatSession')
      } catch (error) {}
    }
  }
}
</script>
